/* Namespaced Safe pairing; native cart events, sections and checkout remain authoritative. */
(function () {
  if (window.tfSafeCart) return;
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  function signature(item) {
    return JSON.stringify([String(item.variant_id || item.id), Object.keys(item.properties || {}).sort().map(function (k) { return [k, String(item.properties[k])]; })]);
  }
  function isSafe(item) {
    return !!(item.properties && item.properties._tf_safe_parent) || /^the-fixers-safe(?:-|$)/.test(item.handle || (item.url || '').split('/products/')[1] || '');
  }
  function orphanUpdates(cart) {
    var parents = new Set(cart.items.filter(function (i) { return !isSafe(i) && i.quantity > 0; }).map(signature));
    var updates = {};
    cart.items.forEach(function (i) {
      // Old unlinked Safe lines cannot be safely attributed: require a fresh selection.
      if (isSafe(i) && !parents.has((i.properties || {})._tf_safe_parent)) updates[i.key] = 0;
    });
    return updates;
  }
  function read() { return nativeFetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); }); }
  function serial(job) {
    var task = queue.then(job, job);
    queue = task.catch(function () {});
    return task;
  }
  function refresh(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    // Native drawer refreshes itself; the cart page needs its native bundled renderer.
    if (window.theme && theme.pubsub && cart.sections) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'tf-safe-cart', cart: cart });
  }
  async function reconcile(cart, sections) {
    cart = cart || await read();
    var updates = orphanUpdates(cart);
    if (!Object.keys(updates).length) return cart;
    var response = await nativeFetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates, sections: sections || [] }) });
    if (!response.ok) throw new Error('Safe removal failed');
    var result = await response.json();
    if (result.errors) throw new Error('Safe removal failed');
    return result;
  }
  function sections() {
    var ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: ids } }));
    return Array.from(new Set(ids)).slice(0, 5);
  }
  window.tfSafeCart = {
    parent: signature,
    isSafe: isSafe,
    orphanUpdates: orphanUpdates,
    ensure: function () { return serial(async function () { var cart = await read(); if (!Object.keys(orphanUpdates(cart)).length) return cart; cart = await reconcile(cart, sections()); refresh(cart); return cart; }); }
  };
  window.fetch = function (input, options) {
    var url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    var method = ((options && options.method) || (input && input.method) || 'GET').toUpperCase();
    var match = url.origin === location.origin && url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/);
    if (!match || method !== 'POST') return nativeFetch(input, options);
    return serial(async function () {
      var kind = match[1], body;
      try { body = JSON.parse(options && options.body); } catch (_) { body = null; }
      // Remove a parent and its Safe in one Shopify update, before native rendering.
      if (body && kind === 'change' && Number(body.quantity) === 0) {
        var before = await read();
        var target = body.line ? before.items[Number(body.line) - 1] : before.items.find(function (i) { return i.key === String(body.id) || String(i.variant_id) === String(body.id); });
        if (target) {
          var remaining = { items: before.items.filter(function (i) { return i.key !== target.key; }) };
          var removals = orphanUpdates(remaining);
          if (Object.keys(removals).length) {
            removals[target.key] = 0;
            body = Object.assign({}, body, { updates: removals });
            delete body.id; delete body.line; delete body.quantity;
            input = root + 'cart/update.js';
            options = Object.assign({}, options, { body: JSON.stringify(body) });
          }
        }
      }
      var response = await nativeFetch(input, options);
      if (!response.ok || kind === 'clear') return response;
      var state = await response.clone().json();
      if (state.errors || state.status >= 400) return response;
      var cart = kind === 'add' ? await read() : state;
      if (!cart.items) return response;
      if (!Object.keys(orphanUpdates(cart)).length) return response;
      var cleaned = await reconcile(cart, (body && body.sections) || sections());
      if (kind === 'add') {
        refresh(cleaned);
        if (cleaned.sections) state.sections = cleaned.sections;
      } else state = cleaned;
      return new Response(JSON.stringify(state), { status: response.status, headers: response.headers });
    });
  };
  function ensure() { window.tfSafeCart.ensure().catch(function (e) { console.warn('Safe cart:', e.message); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure); else ensure();
  window.addEventListener('pageshow', function (e) { if (e.persisted) ensure(); });
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.items && Object.keys(orphanUpdates(e.detail.cart)).length) ensure();
  });
})();